const makeLayer = (data) => JSON.stringify(data)
export default makeLayer